import { FuseAnimate } from "@fuse";
import _ from "@lodash";
import { Checkbox, Radio, withStyles } from "@material-ui/core";
import PaginadorApp from "app/Core/Components/Paginador/PaginadorApp";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as AppActions from "app/store/actions";
import classNames from "classnames";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ReactTable from "react-table";
import { bindActionCreators } from "redux";
import * as Actions from "./Store/Actions/EmpresaProdutoActions";

const styles = theme => ({
    root: {
        color: theme.palette.text.primary,
    }
});

class EmpresaProdutoList extends XAPPComponent {

    componentDidMount() {
        const { listFilter } = this.props;
        listFilter(null, "spvwempresaproduto");
    }

    componentDidUpdate() {
        if (this.props.Produtos.error) {
            this.props.showMessage({
                message: this.props.Produtos.error,
                variant: "error"
            });
            this.props.Produtos.error = null;
        }
    }

    handleChangeRadio = (event, item) => {
        var ASelected = this.props.selected;
        if (!this.isSelected(item.idpessoaformulario)) {
            var obj = item;
            obj["id"] = item.idpessoaformulario;
            obj["label"] = item.nome;
            if (!this.props.multiSelect)
                ASelected = [];
            ASelected.push(obj);
        }
        else {
            ASelected.splice(_.findIndex(ASelected, { id: item.idpessoaformulario }), 1);
        }
        this.props.onChange(ASelected);
    };

    isSelected = (id) => {
        var ASelected = this.props.selected;
        var AExists = false;
        ASelected.forEach((item) => {
            if (item.idpessoaformulario === id || item.id === id)
                AExists = true;
        });
        return AExists;
    };

    getColumns = (_AisLookup) => {
        const { selected, isLookup, multiSelect } = this.props;
        const Columns = [
            {
                Header: "",
                width: 60,
                Cell: row => (
                    <div className="flex items-center">
                        {isLookup && row.original.statusregistro === 1 &&
                            <React.Fragment>
                                {multiSelect ?
                                    <Checkbox
                                        name="selected"
                                        checked={selected?.length > 0 && this.isSelected(row.original.idpessoaformulario)}
                                        onClick={event => {
                                            event.stopPropagation();
                                            this.handleChangeRadio(event, row.original);
                                        }}
                                    />
                                    :
                                    <Radio
                                        name="selected"
                                        checked={selected?.length > 0 && this.isSelected(row.original.idpessoaformulario)}
                                        onClick={event => {
                                            event.stopPropagation();
                                            this.handleChangeRadio(event, row.original);
                                        }}
                                    />
                                }
                            </React.Fragment>
                        }
                    </div>
                )
            },
            {
                Header: "Código",
                accessor: "formulario.codigo",
                width: 120,
            },
            {
                Header: "Nome",
                accessor: "nome",
                className: ""
            },
            {
                Header: "Tipo",
                accessor: "tipodescricao",
                className: ""
            },
            {
                Header: "Valor",
                accessor: "valordescricao",
                className: ""
            }
        ];

        if (!_AisLookup) {
            Columns.splice(0, 1);
        }
        return Columns;
    };

    nextPage = () => {
        const { filter, xappRouteParams, Produtos } = this.props;
        if (Produtos.pagina < Produtos.data[0].paginas) {
            this.props.list("SELECIONAR", xappRouteParams, filter, Produtos.pagina + 1);
        }
    };

    render() {
        const { Produtos, get, xappRouteParams, classes, isLookup } = this.props;

        return (
            <FuseAnimate animation="transition.slideUpIn" delay={300}>
                <ReactTable
                    className={classNames(classes.root, "-striped -highlight border-0")}
                    getTrProps={(state, rowInfo) => {
                        return {
                            className: "cursor-pointer",
                            onClick: () => {
                                if (rowInfo) {
                                    //openEditDialog(rowInfo.original);
                                    get(rowInfo.original.idpessoaformulario, xappRouteParams);
                                }
                            }
                        };
                    }}
                    data={Produtos.data ? Produtos.data : []}
                    columns={this.getColumns(isLookup)}
                    defaultPageSize={100}
                    noDataText="Não existem registros cadastrados!"
                    PaginationComponent={PaginadorApp}
                    nextPage={this.nextPage}
                    paginas={Produtos.data ? Produtos.data[0].paginas : 1}
                    pagina={Produtos.pagina}
                />
            </FuseAnimate>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        get: Actions.get,
        list: Actions.list,
        openNewDialog: Actions.openNewDialog,
        openEditDialog: Actions.openEditDialog,
        showMessage: AppActions.showMessage,
    }, dispatch);
}

function mapStateToProps({ EmpresaProduto }) {
    return {
        Produtos: EmpresaProduto
    };
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(EmpresaProdutoList)));
